/* ============================================================
   RUNNIES — product.runnies.js
   Copiez dans : assets/product.runnies.js
   ============================================================ */

(function () {
  'use strict';

  /* -------- GALERIE -------- */
  function initGallery() {
    const gallery = document.getElementById('rn-gallery');
    if (!gallery) return;

    const slides = gallery.querySelectorAll('.rn-gallery__slide');
    const thumbs = gallery.querySelectorAll('.rn-gallery__thumb');

    function goTo(idx) {
      slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));

      // Pause les vidéos inactives, joue la vidéo active
      slides.forEach((s, i) => {
        const vid = s.querySelector('video');
        if (!vid) return;
        if (i === idx) { vid.play().catch(() => {}); }
        else { vid.pause(); vid.currentTime = 0; }
      });
    }

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => goTo(i));
    });

    // Swipe tactile sur la galerie principale
    let startX = 0;
    const main = gallery.querySelector('.rn-gallery__main');
    if (main) {
      main.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', e => {
        const diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) < 40) return;
        const active = gallery.querySelector('.rn-gallery__slide.is-active');
        const idx = Array.from(slides).indexOf(active);
        if (diff > 0) goTo(Math.min(idx + 1, slides.length - 1));
        else goTo(Math.max(idx - 1, 0));
      }, { passive: true });
    }
  }

  /* -------- OFFRES BUNDLE -------- */
  function initOffers() {
    const offers = document.querySelectorAll('.rn-offer');
    offers.forEach(offer => {
      offer.addEventListener('click', () => {
        offers.forEach(o => o.classList.remove('is-active'));
        offer.classList.add('is-active');
        const radio = offer.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        // Dispatch custom event pour d'éventuelles intégrations
        document.dispatchEvent(new CustomEvent('runnies:offer-selected', {
          detail: { offer: offer.dataset.offer }
        }));
      });
    });
  }

  /* -------- SLIDER UGC -------- */
  function initUGCSlider() {
    const slider = document.getElementById('rn-ugc-slider');
    if (!slider) return;
    const prev = document.querySelector('.rn-ugc__prev');
    const next = document.querySelector('.rn-ugc__next');
    const itemWidth = 280 + 16;

    if (prev) prev.addEventListener('click', () => {
      slider.scrollBy({ left: -itemWidth * 2, behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', () => {
      slider.scrollBy({ left: itemWidth * 2, behavior: 'smooth' });
    });

    // Play/pause vidéos UGC
    slider.querySelectorAll('.rn-ugc__item').forEach(item => {
      const video = item.querySelector('video');
      const playBtn = item.querySelector('.rn-ugc__play');
      if (!video || !playBtn) return;

      playBtn.addEventListener('click', () => {
        if (video.paused) {
          video.play();
          playBtn.classList.add('is-playing');
        } else {
          video.pause();
          playBtn.classList.remove('is-playing');
        }
      });

      video.addEventListener('ended', () => {
        playBtn.classList.remove('is-playing');
      });
    });
  }

  /* -------- ACCORDÉONS -------- */
  function initAccordions() {
    document.querySelectorAll('.rn-accordion').forEach(acc => {
      acc.addEventListener('toggle', () => {
        // Ferme les autres si nécessaire (optionnel : comportement "accordion exclusif")
        // Décommenter les lignes suivantes pour n'en ouvrir qu'un à la fois :
        // if (acc.open) {
        //   document.querySelectorAll('.rn-accordion').forEach(other => {
        //     if (other !== acc) other.removeAttribute('open');
        //   });
        // }
      });
    });
  }

  /* -------- INTERSECTION OBSERVER (vidéos UGC autoplay au scroll) -------- */
  function initVideoObserver() {
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const vid = entry.target.querySelector('video');
        const btn = entry.target.querySelector('.rn-ugc__play');
        if (!vid) return;
        if (entry.isIntersecting) {
          vid.play().catch(() => {});
          if (btn) btn.classList.add('is-playing');
        } else {
          vid.pause();
          if (btn) btn.classList.remove('is-playing');
        }
      });
    }, { threshold: 0.5 });

    document.querySelectorAll('.rn-ugc__item').forEach(item => {
      if (item.querySelector('video')) observer.observe(item);
    });
  }

  /* -------- INIT -------- */
  document.addEventListener('DOMContentLoaded', () => {
    initGallery();
    initOffers();
    initUGCSlider();
    initAccordions();
    initVideoObserver();
  });

})();
